/**
 * Utility functions for admin role checks
 */

export type AdminRole = 'ADMIN' | 'SME' | 'ORG_ADMIN';

/**
 * Check if a user role is considered an admin role
 * @param role - The user's role
 * @returns true if the role is an admin role, false otherwise
 */
export const isAdminRole = (role: string | null): boolean => {
  if (!role) return false;
  
  const adminRoles: AdminRole[] = ['ADMIN', 'SME', 'ORG_ADMIN'];
  return adminRoles.includes(role as AdminRole);
};

/**
 * Get all admin roles
 * @returns Array of admin role strings
 */
export const getAdminRoles = (): AdminRole[] => {
  return ['ADMIN', 'SME', 'ORG_ADMIN'];
};

/**
 * Check if a user has permission to access admin features
 * @param role - The user's role
 * @param isAuthenticated - Whether the user is authenticated
 * @returns true if the user has admin access, false otherwise
 */
export const hasAdminAccess = (role: string | null, isAuthenticated: boolean): boolean => {
  return isAuthenticated && isAdminRole(role);
}; 